import {Multicall,ContractCallResults,ContractCallContext} from 'ethereum-bsc-multicall';
import {getRaidAbi} from '../app/raidAbi'

const raidAbi = getRaidAbi()
const multicall = new Multicall({
    nodeUrl: 'https://bsc-dataseed.binance.org/'
})

export const getAllPoolsContext = (wallet:any) => {
    const poolIndexList: Array<number> = []
    for(let i = 0; i < 76; i++){
        poolIndexList.push(i)
    }
    const contractCallContext: ContractCallContext<{}>[] = [
        {
            reference: 'getAllPools',
            contractAddress: '0xcfA857d6EC2F59b050D7296FbcA8a91D061451f3',
            abi: raidAbi,
            calls: poolIndexList.map(number => {
                return { reference: 'poolCall', methodName: 'poolInfo', methodParameters: [number] }
            })
        },
        {
            reference: 'getAllocationAmounts',
            contractAddress: '0xcfA857d6EC2F59b050D7296FbcA8a91D061451f3',
            abi: raidAbi,
            calls: poolIndexList.map(number => {
                return { reference: 'getAllocationAmounts', methodName: 'userInfo', methodParameters: [number, wallet] }
            })
        },
    ];
    
    
    return multicall.call(contractCallContext).then(response => {
        const results: ContractCallResults = response
        return results
    })
}


